import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
@Component({
  selector: 'app-guest',
  imports: [RouterOutlet],
  template: `
    <div class="h-dvh flex">
      <div class="flex-1 bg-base-200 overflow-auto">
        <router-outlet />
      </div>
    </div>
  `,
})
export class GuestLayout {}
